import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum ChangePasswordFieldIds {
    oldPassword = 'old-password',
    newPassword = 'new-password',
    repeatNewPassword = 'repeat-new-password',
}

export enum ChangePasswordFieldNames {
  oldPassword = 'oldPassword',
  newPassword = 'newPassword',
  repeatNewPassword = 'repeatNewPassword',
}

export type PasswordAnswersState = {
  [ChangePasswordFieldNames.oldPassword]: string;
  [ChangePasswordFieldNames.newPassword]: string;
  [ChangePasswordFieldNames.repeatNewPassword]: string;
};

export type InitialPAsswordChangeState = {
    answers :{
        passwordFields:PasswordAnswersState
    }
}

export const initialPasswordChangeState:InitialPAsswordChangeState = {
    answers: {
        passwordFields: {
            [ChangePasswordFieldNames.oldPassword]: '',
            [ChangePasswordFieldNames.newPassword]: '',
            [ChangePasswordFieldNames.repeatNewPassword]: '',
        },
    },
};

const reducers = {
    setAnswers: (
        state,
        action:PayloadAction<{
            [key: string]: Record<ChangePasswordFieldNames, string>;
          }>,
    ) => ({
        ...state,
        answers: {
            ...state.answers,
            ...action.payload,
        },
    }),
    setDefaultInitialPasswordState: () => ({
        ...initialPasswordChangeState,
    }),
};

const changePasswordSlice = createSlice({
    name: 'changePasswordSlice',
    initialState: initialPasswordChangeState,
    reducers,
});

export default changePasswordSlice;
